module.exports = __webpack_public_path__ + "img/daohang.eef689f6.png";